import React, {useCallback, useEffect, useMemo, useState} from "react";
import useEmblaCarousel from "embla-carousel-react";
import classNames from "classnames";
import {useModalStore} from "@/Stores/Site/Product";
import Video from "@/Components/Video";
import Picture from "@/Components/Picture";
import Svg from "@/Components/Svg";
import Share from "@/Pages/Site/Product/Share";
import FavoritesCheckbox from "@/Components/Site/FavoritesCheckbox";
import "@/Scss/Site/Product/mainCarousel.scss";

const MainCarousel = (props) => {
    const {product = {}, productDataCurrent = {}, type = ''} = props;
    const {imgDetail = null, h1 = '', article = ''} = product;

    const [selectedIndex, setSelectedIndex] = useState(0);

    const openZoomImageModal = useModalStore(state => state.openZoomImageModal);

    const isVideo = (src) => /\.(mp4|webm|ogg)$/i.test(src);
    const media = useMemo(() => {
        return (imgDetail?.split(';') ?? [])
            .filter(Boolean)
            .map((src) => ({
                src,
                type: isVideo(src) ? 'video' : 'image'
            }));
    }, [imgDetail]);

    // Текущая цена для отправки в аналитику
    const currentPrice = productDataCurrent?.price_minimum !== 0
        ? productDataCurrent?.price_minimum
        : productDataCurrent?.card_price ?? 0;

    const [thumbsCarouselRef, thumbsCarouselApi] = useEmblaCarousel({
        axis: 'y',
        // align: 'start',
        dragFree: true,
        containScroll: 'keepSnaps',
    });

    const [horizontalRef, horizontalApi] = useEmblaCarousel();

    const onThumbClick = useCallback(
        (index) => {
            if (!thumbsCarouselApi || !horizontalApi) return;
            horizontalApi.scrollTo(index);
        },
        [thumbsCarouselApi, horizontalApi]
    );

    const onSelect = useCallback(() => {
        if (!horizontalApi || !thumbsCarouselApi) return;
        setSelectedIndex(horizontalApi.selectedScrollSnap());
        thumbsCarouselApi.scrollTo(horizontalApi.selectedScrollSnap());
    }, [horizontalApi, thumbsCarouselApi, setSelectedIndex]);

    useEffect(() => {
        if (!horizontalApi) return;

        horizontalApi.on('select', onSelect);
        horizontalApi.on('reInit', onSelect);

        return () => {
            horizontalApi.off('select', onSelect);
            horizontalApi.off('reInit', onSelect);
        };
    }, [horizontalApi, onSelect]);

    /**
     * Модальное окно "Увеличение изображения"
     * @param index
     */
    const onOpenZoomImageModal = (index) => {
        if (type !== 'product') return;

        openZoomImageModal(index);
    };

    return (
        <div className={classNames('productMainCarousel', {
            [`productMainCarousel--${props.className}`]: props.className
        })}>
            <div className={`productMainCarousel__vertical`}>
                <div className={`embla`}>
                    <div ref={thumbsCarouselRef} className={`embla__viewport`}>
                        <div className={`embla__container`}>
                            {media.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={classNames('embla__slide', {'embla__slide--active': index === 0})}
                                        onClick={() => onThumbClick(index)}
                                    >
                                        <div
                                            className={classNames('embla__inner', {'embla__inner--active': index === selectedIndex})}>
                                            {item.type === 'video' && (
                                                <Video
                                                    source={[item.src]}
                                                    style={{width: '100%', height: '100%'}}
                                                    preload={`metadata`}
                                                    controls={false}
                                                    autoPlay
                                                    loop
                                                />
                                            )}
                                            {item.type === 'image' && (
                                                <Picture src={item.src} alt={`${h1} ${article}`} />
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`productMainCarousel__horizontal`}>
                <div className={`productMainCarousel__backButton`} onClick={() => window.history.back()}>
                    <Svg id={`arrows-left-product`} className={`svg--backButton`} />
                </div>
                <div className={`productMainCarousel__shareAndFavorites`}>
                    <Share {...props}/>
                    <div className={`additionalInfoContainer__favourites`}>
                        <FavoritesCheckbox {...props} el={{...product, currentPrice: currentPrice}} />
                    </div>
                </div>
                <div className={`embla`}>
                    <div ref={horizontalRef} className={`embla__viewport`}>
                        <div className={`embla__container`}>
                            {media.map((item, index) => {
                                // const imageIndex = imagesMap.get(item.src);

                                return (
                                    <div key={index} className={`embla__slide`}>
                                        <div className={`embla__inner`} onClick={() => onOpenZoomImageModal(index)}>
                                            {item.type === 'video' && (
                                                <Video
                                                    source={[item.src]}
                                                    style={{width: '100%', height: '100%'}}
                                                    preload={`metadata`}
                                                    controls={false}
                                                    autoPlay
                                                    loop
                                                />
                                            )}
                                            {item.type === 'image' && (
                                                <Picture
                                                    src={item.src}
                                                    alt={`${h1} ${article}`}
                                                    className={`mainCarousel`}
                                                />
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainCarousel;
